import React, { useState } from 'react';
import styles from './Navbar.module.css';
import { useNavigate, useLocation } from "react-router-dom";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation(); // current route detect करेगा

  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);




    
  };

  // helper function → check active tab
  const isActive = (path) => location.pathname === path;

  return (
    <div className={styles.navbarContainer}>
      <nav className={styles.navbar}>
        <div className={styles.logo} onClick={() => navigate("/")}>
          <img src="Images/newLogo.png" alt="Bruno Vision Care logo" height="40" />
        </div>

        <div className={styles.navLinks}>
          <span
            className={`${styles.navLink} ${isActive("/fusion-technology") ? styles.activeNav : ""}`}
            onClick={() => navigate("/fusion-technology")}
          >
            Innovation
          </span>

          <span
            className={`${styles.navLink} ${isActive("/for-professionals") ? styles.activeNav : ""}`}
            onClick={() => navigate("/for-professionals")}
          >
            For Professionals
          </span>

          <span
            className={`${styles.navLink} ${isActive("/for-patients") ? styles.activeNav : ""}`}
            onClick={() => navigate("/for-patients")}
          >
            For Patients
          </span>

          <span
            className={`${styles.navLink} ${isActive("/about-us") ? styles.activeNav : ""}`}
            onClick={() => navigate("/about-us")}
          >
            About Us
          </span>
           <span
            className={`${styles.navLink} ${isActive("") ? styles.activeNav : ""}`}
            onClick={() => navigate("")}
          >
         Newsroom
          </span>

          {/* <div className={styles.dropdown}>
            <a
              href="#newsroom"
              className={`${styles.navLink} ${location.hash === "#newsroom" ? styles.activeNav : ""}`}
            >
              Newsroom ▾
            </a>
            <div className={styles.dropdownMenu}>
              <a href="#press-releases">Press Releases</a>
              <a href="#events">Events</a>
              <a href="#articles">Articles</a>
              <a href="#blogs">Blogs</a>
            </div>
          </div> */}

          <span
            className={`${styles.navLink} ${isActive("/contact-us") ? styles.activeNav : ""}`}
            onClick={() => navigate("/contact-us")}
          >
            Contact Us
          </span>
        </div>

        <div className={styles.hamburger} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>

      {/* Offcanvas menu */}
      <div className={`${styles.offcanvas} ${showMenu ? styles.open : ''}`}>
        <div className={styles.offcanvasClose} onClick={toggleMenu}>
          &times;
        </div>

        <span
          className={`${styles.navLink} ${isActive("/fusion-technology") ? styles.activeNav : ""}`}
          onClick={() => navigate("/fusion-technology")}
        >
          Innovation
        </span>

        <span
          className={`${styles.navLink} ${isActive("/for-professionals") ? styles.activeNav : ""}`}
          onClick={() => navigate("/for-professionals")}
        >
          For Professionals
        </span>

        <span
          className={`${styles.navLink} ${isActive("/for-patients") ? styles.activeNav : ""}`}
          onClick={() => navigate("/for-patients")}
        >
          For Patients
        </span>

        <span
          className={`${styles.navLink} ${isActive("/about-us") ? styles.activeNav : ""}`}
          onClick={() => navigate("/about-us")}
        >
          About Us
        </span>
         <span
          className={`${styles.navLink} ${isActive("") ? styles.activeNav : ""}`}
          onClick={() => navigate("")}
        >
    Newsroom
        </span>

        {/* <div className={styles.dropdown}>
          <a
            href="#newsroom"
            className={`${styles.navLink} ${location.hash === "#newsroom" ? styles.activeNav : ""}`}
          >
            Newsroom ▾
          </a>
          <div className={styles.dropdownMenu}>
            <a href="#press-releases">Press Releases</a>
            <a href="#events">Events</a>
            <a href="#articles">Articles</a>
            <a href="#blogs">Blogs</a>
          </div>
        </div> */}

        <span
          className={`${styles.navLink} ${isActive("/contact-us") ? styles.activeNav : ""}`}
          onClick={() => navigate("/contact-us")}
        >
          Contact Us
        </span>
      </div>
    </div>
  );
};

export default Navbar;
